import { DeleteOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

const defaultValue = '';

const FieldListEditor = ({ value, id, actionText, required, validations, translate, ...rest }) => {
  const { t } = useTranslation(translate || 'common');
  
  return (<>
    <Form.List name={id} {...rest} initialValue={[defaultValue]}>
      {(fields, { add, remove }) => {
        return <>
          {fields.map((field, index) => {
            return <Input.Group compact className="mb-2 flex items-start" key={index}>
              <Form.Item {...field} rules={[{ required: required }].concat(validations || [])} className="w-full mb-0">
                <Input defaultValue={''} className="w-full"/>
              </Form.Item>
              {index !== 0 && !!value && <div
                onClick={() => remove(index)}
                className="text-center cursor-pointer pl-4 flex pt-2 justify-center hover:text-primary"
                style={{ height: '40px', minWidth: '30px' }}>
                <DeleteOutlined/>
              </div>}
            </Input.Group>;
          })}
          <div className="text-sm text-primary mt-2 cursor-pointer">
            <span onClick={() => add(defaultValue)}
              className="cursor-pointer">{t(actionText)}</span>
          </div>
        </>;
      }}
    </Form.List>
  </>);
};

export default memo(FieldListEditor);

FieldListEditor.propTypes = {
  id: PropTypes.string,
  value: PropTypes.array,
  required: PropTypes.bool,
  validations: PropTypes.array,
  actionText: PropTypes.string,
  translate: PropTypes.string,
  onChange: PropTypes.func
};

FieldListEditor.defaultProps = {
  value: [],
  actionText: 'elementAdd'
};

export const renderFieldListEditor = ({ formItemProps, field }) => {
  
  return (
    <Form.Item {...formItemProps} required={field?.required}>
      <FieldListEditor {...field}/>
    </Form.Item>
  );
};
